import { Field } from 'formik';
import { FieldProps } from 'formik/dist/Field';
import React from 'react';
import { FormControlProps } from 'react-bootstrap/FormControl';
import { DecoratedFormUnit } from '../../base/DecoratedFormUnit';
import { BsForm, InputProps, parseInputProps } from '../../base/Form';

export type TextInputProps = InputProps & {
  type?: string;
};

const defaultProps = {
  type: 'text',
};

export function TextInputP(props: TextInputProps) {
  const { inputProps, unitProps } = parseInputProps(props);

  return (
    <DecoratedFormUnit {...unitProps} id={props.id}>
      <BsForm.Control isInvalid={!!unitProps.error} {...(inputProps as FormControlProps)} />
    </DecoratedFormUnit>
  );
}

export const TextInput = TextInputP as typeof TextInputP & {
  defaultProps: typeof defaultProps;
};
TextInput.defaultProps = defaultProps;

export function TextField(props: React.ComponentProps<typeof TextInput>) {
  const { name, ...rest } = props;

  return (
    <Field name={name}>
      {(fp: FieldProps) => {
        return (
          <TextInput
            {...fp.field}
            {...rest}
            error={fp.meta.touched && fp.meta.error}
            disabled={rest.disabled || fp.form.isSubmitting}
          />
        );
      }}
    </Field>
  );
}
